export default __webpack_public_path__ + "static/media/basketball.9427ebee.gif";